import { useEffect } from 'react';

import usePageInfoUpdater from '../hooks/usePageInfoUpdater';
import usePageMetaInfo from '../hooks/usePageMetaInfo';
import { TCustomPageInfo } from '../types';

const addPageInfo = <Props extends {}>(pageInfo: TCustomPageInfo) => (
  Component: React.ComponentType<Props>
) => (props: Props) => {
  const updatePageInfo = usePageInfoUpdater();
  const metaInformation = usePageMetaInfo();
  useEffect(() => {
    const combinedMetaInfo = pageInfo?.metaInformation
      ? { ...metaInformation, ...pageInfo.metaInformation }
      : metaInformation;

    updatePageInfo?.({
      ...pageInfo,
      metaInformation: combinedMetaInfo,
    });
  }, [metaInformation, updatePageInfo]);
  return <Component {...props} />;
};

export default addPageInfo;
